import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const NewTask = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default NewTask;
